<label
  class="input-wrapper px-2 rounded-md border bg-white flex gap-1 z-[1] relative items-center h-10"
  [class.filled]="style === 'filled'"
>
  <ng-content select="[ctrPreffix]"></ng-content>
  <div class="relative flex-1 self-stretch">
    <input
      class="input outline-none w-full text-sm text-ctr"
      [type]="inputType"
      [class.alone]="!label"
      [formControl]="control"
      (blur)="onBlur()"
      [name]="name"
      #input
    />
    <span class="absolute label" [class.content]="valueSignal()">{{ label }}</span>
  </div>
  <ng-content select="[ctrSuffix]"></ng-content>
</label>
@if (hint) {
  <span class="text-xs hint animate-fade-down animate-once animate-ease-out animate-duration-300">{{ hint }}</span>
}
